// @generated by TypeGen from LogbookApi/Routes - DO NOT EDIT

import type { ILogbookAppStatusResult } from "../LogbookApp/AppStatus"
import type { IAppResponse, IReleasesResponse, IServerInfoResponse } from "../LogbookApp/Routes"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface RoutesEndpoints {
  "GET /api/release": {
    params: {};
    query: {};
    request: never;
    response: IReleasesResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "GET /api/server": {
    params: {};
    query: {};
    request: never;
    response: IServerInfoResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "GET /api/status": {
    params: {};
    query: {};
    request: never;
    response: ILogbookAppStatusResult;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/reset": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: {};
  };
}

export const routesEndpoints = {
  "GET /api/release": { targets: ["app"], permission: {} },
  "GET /api/server": { targets: ["app"], permission: {} },
  "GET /api/status": { targets: ["app"], permission: {} },
  "POST /api/reset": { targets: ["app"], permission: {} },
} as const;

export class Routes {
  constructor(private client: ApiClient) {}

  release = {
    get: (a: ApiArgs<RoutesEndpoints, "GET /api/release">) => ({
      call: (): Promise<IReleasesResponse> => {
        assertTarget(this.client, "GET /api/release", routesEndpoints["GET /api/release"].targets);
        return this.client.call<IReleasesResponse>("GET /api/release", a);
      },
      url: (): string => this.client.url("GET /api/release", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };

  server = {
    get: (a: ApiArgs<RoutesEndpoints, "GET /api/server">) => ({
      call: (): Promise<IServerInfoResponse> => {
        assertTarget(this.client, "GET /api/server", routesEndpoints["GET /api/server"].targets);
        return this.client.call<IServerInfoResponse>("GET /api/server", a);
      },
      url: (): string => this.client.url("GET /api/server", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };

  status = {
    get: (a: ApiArgs<RoutesEndpoints, "GET /api/status">) => ({
      call: (): Promise<ILogbookAppStatusResult> => {
        assertTarget(this.client, "GET /api/status", routesEndpoints["GET /api/status"].targets);
        return this.client.call<ILogbookAppStatusResult>("GET /api/status", a);
      },
      url: (): string => this.client.url("GET /api/status", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };

  app = {
    reset: (a: ApiArgs<RoutesEndpoints, "POST /api/reset">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/reset", routesEndpoints["POST /api/reset"].targets);
        return this.client.call<IAppResponse>("POST /api/reset", a);
      },
      url: (): string => this.client.url("POST /api/reset", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };
}
